import { render, staticRenderFns } from "./KeyFinanceRatio.vue?vue&type=template&id=89e4809e&scoped=true"
import script from "./KeyFinanceRatio.vue?vue&type=script&lang=js"
export * from "./KeyFinanceRatio.vue?vue&type=script&lang=js"
import style0 from "./KeyFinanceRatio.vue?vue&type=style&index=0&id=89e4809e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e4809e",
  null
  
)

export default component.exports